// Module
var code = "<div class=\"kov-icon-circle\"> <span ng-show=\"ctrl.sIcon\" ng-include=\"ctrl.sIcon\"></span> </div> <div> <div class=\"kov-header-title font-large\">{{ctrl.sTitle}}</div> <div class=\"subtitle-font-size\">{{ctrl.sSubtitle}}</div> </div> ";
// Exports
module.exports = code;